<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { RouterView } from 'vue-router'
import { useAuthStore, authService, ConfirmDialog, useWebSocketLifecycle } from '@adaptcx/shared'

const authStore = useAuthStore()
let stopSessionWatcher: (() => void) | null = null

// Shared platform /ws connection, driven by useWebSocketLifecycle, which
// watches the Pinia access token and connects/disconnects as it appears/
// clears. IDP-domain WS handlers (review-queue live updates) register on this
// connection in slice 3.2. Mirrors dars-officer-portal App.vue.
useWebSocketLifecycle()

onMounted(async () => {
  authStore.initFromStorage()
  const token = localStorage.getItem('access_token') || sessionStorage.getItem('access_token')
  if (token) {
    try {
      await authStore.fetchUser()
      stopSessionWatcher = authService.startSessionExpiryWatcher()
    } catch (e) {
      console.error('Failed to restore auth state:', e)
    }
  }
})

onUnmounted(() => {
  if (stopSessionWatcher) {
    stopSessionWatcher()
    stopSessionWatcher = null
  }
})
</script>

<template>
  <RouterView />
  <!-- Global confirm dialog — any view triggers it via useConfirm().confirm({...}).
       Replaces native window.confirm() per feedback_no_native_alert_confirm. -->
  <ConfirmDialog />
</template>
